import { Alert } from 'react-bootstrap';
import useOpoToDo from '@nkr/store/opo/hooks/use-opo-to-do';
import { SettingsTab } from '../../settings/tabs';
import { ActionCenterTab } from '../tabs';
import { IToDoItem } from './models';
import OpoToDo from './index';

const complianceSettingsTabs: Record<string, SettingsTab> = {
    'timezone': SettingsTab.Profile,
    'addresses': SettingsTab.Addresses,
    'opo-user': SettingsTab.PortalUsers,
    'contacts': SettingsTab.Contacts,
    'packaging': SettingsTab.Packaging
};

interface IProps {
    onTabSelect: (tab: ActionCenterTab) => void,
    onSettingsSelect: (tab: SettingsTab) => void
}

const ToDoTab = ({ onTabSelect, onSettingsSelect }: IProps) => {
    const { pendingCaseCount, pendingSwapCount, complianceItems, loading } = useOpoToDo();

    if (loading) {
        return null;
    }

    const toDoItems: IToDoItem[] = [];

    if (pendingCaseCount != null) {
        toDoItems.push({ key: 'pending-dd-cases', label: 'Pending DD Cases', count: pendingCaseCount, onClick: () => onTabSelect(ActionCenterTab.DeceasedDonorCases) });
    }

    if (pendingSwapCount != null) {
        toDoItems.push({ key: 'pending-ld-swaps', label: 'Pending LDK Moves', count: pendingSwapCount, onClick: () => onTabSelect(ActionCenterTab.LivingDonorMoves) });
    }

    const compliance: IToDoItem[] = (complianceItems || []).map(item => {
        const settingsTab = complianceSettingsTabs[item.key];

        return {
            key: item.key,
            label: item.label,
            count: item.count,
            onClick: settingsTab ? () => onSettingsSelect(settingsTab) : undefined
        };
    });

    return (
        <>
            {(pendingCaseCount == null || pendingSwapCount == null || complianceItems == null) && (
                <Alert bsStyle='danger'>Some to-do items could not be loaded</Alert>
            )}

            <OpoToDo toDoItems={toDoItems} complianceItems={compliance} />
        </>
    );
}

export default ToDoTab;
